/**
 * `["A", "B", "C"]` → `"A, B and C"`. No Oxford comma, matching the rest of the
 * site's copy.
 */
export function joinWithAnd(items: readonly string[]): string {
  if (items.length < 2) {
    return items[0] ?? "";
  }

  return `${items.slice(0, -1).join(", ")} and ${items.at(-1)}`;
}
